import { post } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var wmsCenter = global.wmsCenter
let stockName = global.stockName
var name1 = global.contractName
var crmServer = global.crmServer
var wmsStockName = global.wmsStockName
var signature = global.signature
var crmServer3 = global.crmServer3
var wmsAccessName = global.wmsAccessName

// 所在仓库列表
// export const getOrganizationNameList = p => post(`/${wmsCenter}/wmsApi/getOrganizationNameList`, p)
// export const getOrganizationNameList = p => post(`/${crmServer}/api/findUserTenantRelList`, p)
export let getOrganizationNameList = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/api/findUserTenantRelList`, p)
  } else {
    return post(`/${crmServer}/api/findUserTenantRelList`, p)
  }
}

// 库存记录--入库记录
export const getInStockThreadList = p => post(`/${wmsCenter}/wmsApi/getInStockThreadList`, p)
// 库存记录--出库记录
export const getOutStockThreadList = p => post(`/${wmsCenter}/wmsApi/getOutStockThreadList`, p)
// 库存记录--转货记录
export const getEmptyChangeRecordForHz = p => post(`/${wmsStockName}/tEmpty/getEmptyChangeRecordForHz`, p)

// 货物类型
export const getDictionary = p => post(`/${wmsStockName}/b/dictionary/getDictionary`, p)
export const getDictionaryAll = p => post(`/${wmsStockName}/b/dictionary/getDictionaryAll`, p)
// 库存明细列表
export const getStockThreadList = p => post(`/${wmsCenter}/wmsApi/getStockThreadList`, p)
// 库存明细列表统计
export const getStockThreadTotalWN = p => post(`/${wmsCenter}/wmsApi/getStockThreadTotalWN`, p)

// 控货列表
export const cVirtualControlList = p => post(`/${stockName}/sVirtualControlRecord/cVirtualControlList`, p)
// 控货明细列表
export const SVRlist = p => post(`/${stockName}/sVirtualControlRecord/list`, p)
// 添加控货
export const SVRadd = p => post(`/${stockName}/sVirtualControlRecord/add`, p)
// 获取剩余量
export const surplusWeight = p => post(`/${stockName}/sVirtualControlRecord/surplusWeight`, p)
// 提货
export const sVirtualBillAdd = p => post(`/${stockName}/sVirtualBill/add`, p)
// 转货
export const sVirtualChangeAdd = p => post(`/${stockName}/sVirtualChange/add`, p)
// 提货单据
export const SVBlist = p => post(`/${stockName}/sVirtualBill/list`, p)
// 提货单据详情
export const SVBdetail = p => post(`/${stockName}/sVirtualBill/detail`, p)
// 提货单据-车辆放行
export const SVBVehicleRelease = p => post(`/${stockName}/sVirtualBill/billVehicleRelease`, p)
// 转货单据
export const SVClist = p => post(`/${stockName}/sVirtualChange/list`, p)
// 转货单据详情
export const SVCdetail = p => post(`/${stockName}/sVirtualChange/detail`, p)
// 通用性配置（平）
export const findExtAttritude = p => post(`/${stockName}/cDictionary/findExtAttritude`, p)
// 虚捆提货单删除
export const SVBdelete = p => post(`/${stockName}/sVirtualBill/delete`, p)
// 虚捆转货单删除
export const SVCdelete = p => post(`/${stockName}/sVirtualChange/delete`, p)
// 校验货物剩余件数（平）
export const remaindeGoodsNum = p => post(`/${stockName}/sVirtualGoods/remaindeGoodsNum`, p)
// 入库记录统计（梁）
export const getInStockThreadWN = p => post(`/${wmsCenter}/wmsApi/getInStockThreadWN`, p)
// 出库记录统计（梁）
export const getOutStockThreadWN = p => post(`/${wmsCenter}/wmsApi/getOutStockThreadWN`, p)
// 出库记录统计（梁）
export const getEmptyChangeRecordForHzWN = p => post(`/${wmsStockName}/tEmpty/getEmptyChangeRecordForHzWN`, p)
// 人车维护（平）
export const addVirtualBillCarriageInfos = p => post(`/${stockName}/sVirtualBill/addVirtualBillCarriageInfos`, p)
// 通用性配置-判断是否必填（平）
export const selectCommonDictionary = p => post(`/${stockName}/cDictionary/selectCommonDictionary`, p)
// 车辆司机记录（平）
export const sBillCarriageInfoList = p => post(`/${stockName}/sBillCarriageInfo/list`, p)
// 车辆司机记录删除（平）
export const sCarriageLogDelete = p => post(`/${stockName}/sBillCarriageInfo/carriageLogDelete`, p)
// 提单作废（常）
export const cancelEmptyBill = p => post(`/${stockName}/sVirtualBill/cancelEmptyBill`, p)
// 根据一级客户，仓库查询二级货主（杨）
export const getTEmptyCargoControlList = p => post(`/${wmsCenter}/wmsApi/getTEmptyCargoControlList`, p)
// 二级货主下得仓库下拉(梁)
export const getOrganizationDropDownForHZ = p => post(`/${signature}/t/goods/control/master/getOrganizationDropDownForHZ`, p)
// 二级货主下得一级货主下拉(梁)
export const getOneCustomerDropDownForHZ = p => post(`/${signature}/t/goods/control/master/getOneCustomerDropDownForHZ`, p)
// 二级货主控货(梁)
export const getMasterListForHZ = p => post(`/${signature}/t/goods/control/master/getMasterListForHZ`, p)
// 出库记录（磅单-尚）
export const getImgShow = p => post(`/${wmsStockName}/tWhImg/getImgShow`, p)
// 进仓记录-查询（亚）
export const getConfirmedList = p => post(`/${wmsCenter}/wmsApi/getConfirmedList`, p)
// 进仓记录-总吨数、总件数（亚）
export const getConfirmedNumber = p => post(`/${wmsCenter}/wmsApi/getConfirmedNumber`, p)
// 控货查询
export const getStockCustomerList = p => post(`/${wmsCenter}/wmsApi/getStockCustomerList`, p)
// 控货查询重量
export const getStockCustomerListWn = p => post(`/${wmsCenter}/wmsApi/getStockCustomerListWn`, p)
// 识别车号
export const formatVehNo = p => post(`/${stockName}/sBillCarriageInfo/formatVehNo`, p)
export const getLatestVehicleDriverInfo = p => post(`/${stockName}/sBillCarriageInfo/getLatestVehicleDriverInfo`, p)
// 货物记录 中远进仓记录
export const socAlreadyEnteredZy = p => post(`/${wmsAccessName}/instockThread/socAlreadyEnteredZy`, p)
// 货物记录 中远进仓记录统计
export const getSocAlreadyEnteredZyWeightNumber = p => post(`/${wmsAccessName}/instockThread/getSocAlreadyEnteredZyWeightNumber`, p)
// 一级货主控货20240507
export const getMasterListForHZZy = p => post(`/${signature}/t/goods/control/master/getMasterListForHZZy`, p)
// 一级货主下的二级货主
export const masterListZy = p => post(`/${signature}/t/goods/control/master/listZy`, p)

// 删除人车校验
export const checkWhBillDriver = p => post(`/${wmsCenter}/wmsApi/checkWhBillDriver`, p)
